export const REACTION_OPTIONS = [
  { token: 'thumbsup', emoji: '\uD83D\uDC4D', label: 'thumbs up' },
  { token: 'thumbsdown', emoji: '\uD83D\uDC4E', label: 'thumbs down' },
  { token: 'laugh', emoji: '\uD83D\uDE02', label: 'laughing' },
  { token: 'hooray', emoji: '\uD83C\uDF89', label: 'party' },
  { token: 'confused', emoji: '\uD83D\uDE15', label: 'confused' },
  { token: 'heart', emoji: '\u2764\uFE0F', label: 'heart' },
  { token: 'fire', emoji: '\uD83D\uDD25', label: 'fire' },
  { token: 'clap', emoji: '\uD83D\uDC4F', label: 'clap' },
  { token: 'eyes', emoji: '\uD83D\uDC40', label: 'eyes' },
  { token: 'thinking', emoji: '\uD83E\uDD14', label: 'thinking' },
  { token: 'rocket', emoji: '\uD83D\uDE80', label: 'rocket' },
  { token: 'check', emoji: '\u2705', label: 'check' },
  { token: 'star', emoji: '\u2B50', label: 'star' },
  { token: 'wave', emoji: '\uD83D\uDC4B', label: 'wave' },
  { token: 'pray', emoji: '\uD83D\uDE4F', label: 'pray' },
  { token: 'muscle', emoji: '\uD83D\uDCAA', label: 'muscle' },
  { token: 'party', emoji: '\uD83E\uDD73', label: 'partying face' },
  { token: 'smile', emoji: '\uD83D\uDE04', label: 'smile' },
  { token: 'grin', emoji: '\uD83D\uDE01', label: 'grin' },
  { token: 'wink', emoji: '\uD83D\uDE09', label: 'wink' },
  { token: 'cry', emoji: '\uD83D\uDE22', label: 'cry' },
  { token: 'mindblown', emoji: '\uD83E\uDD2F', label: 'mind blown' },
  { token: 'skull', emoji: '\uD83D\uDC80', label: 'skull' },
  { token: 'angry', emoji: '\uD83D\uDE20', label: 'angry' },
  { token: 'sunglasses', emoji: '\uD83D\uDE0E', label: 'cool' },
  { token: 'hundred', emoji: '\uD83D\uDCAF', label: '100' },
  { token: 'sparkles', emoji: '\u2728', label: 'sparkles' },
  { token: 'shrug', emoji: '\uD83E\uDD37', label: 'shrug' },
  { token: 'raised_hands', emoji: '\uD83D\uDE4C', label: 'raised hands' },
  { token: 'warning', emoji: '\u26A0\uFE0F', label: 'warning' },
  { token: 'calendar', emoji: '\uD83D\uDCC5', label: 'calendar' },
  { token: 'clock', emoji: '\u23F0', label: 'alarm clock' },
  { token: 'bulb', emoji: '\uD83D\uDCA1', label: 'idea' }
];

const TOKEN_TO_EMOJI = REACTION_OPTIONS.reduce((acc, option) => {
  acc[option.token] = option.emoji;
  return acc;
}, {});

function stripVariationSelectors(value) {
  return String(value || '').replace(/\uFE0F/g, '');
}

const EMOJI_TO_TOKEN = REACTION_OPTIONS.reduce((acc, option) => {
  acc[option.emoji] = option.token;
  const strippedEmoji = stripVariationSelectors(option.emoji);
  if (strippedEmoji) {
    acc[strippedEmoji] = option.token;
  }
  return acc;
}, {});

export const REACTION_TOKENS = REACTION_OPTIONS.map((option) => option.token);
export const REACTION_TOKEN_SET = new Set(REACTION_TOKENS);

export function normalizeReactionToken(value) {
  if (!value) return value;
  const normalizedValue = String(value).trim();
  if (REACTION_TOKEN_SET.has(normalizedValue)) return normalizedValue;
  if (EMOJI_TO_TOKEN[normalizedValue]) return EMOJI_TO_TOKEN[normalizedValue];
  const strippedValue = stripVariationSelectors(normalizedValue);
  if (EMOJI_TO_TOKEN[strippedValue]) return EMOJI_TO_TOKEN[strippedValue];
  return value;
}

export function toReactionEmoji(value) {
  if (!value) return value;
  if (TOKEN_TO_EMOJI[value]) return TOKEN_TO_EMOJI[value];
  return value;
}
